// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"666f3ccf","97":"d45eb2ce","103":"7a686a70","304":"a6968f04","369":"49ceb9d1","518":"da6ed524","821":"6662d83b","839":"b0c2078e","844":"20d661c3","952":"ed33c4bf"}[chunkId] + ".chunk.js";
};